import comp from "./TagFolders.js";
export default comp;
